import loadable from '@loadable/component';

export const MbrSiteWrapper = loadable(
  () => import(/* webpackChunkName: "mbr-site" */ './MbrSiteWrapper'),
);
